import React from 'react';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
const BackButton = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Button, {
    variant: "light",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " ", t('back'));
};
export default BackButton;